/**
 * NGlow Cart Fix - Restores missing cart functions 
 * if core theme scripts are blocked by license checks.
 */

window.refreshCartDrawer = async function() {
    const drawer = document.querySelector('#CartDrawer');
    if (drawer) drawer.classList.add('is-loading');

    try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}?section_id=nglow-cart-drawer`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newContent = html.querySelector('#CartDrawer');
        const currentDrawer = document.querySelector('#CartDrawer');
        if (newContent && currentDrawer) {
            currentDrawer.innerHTML = newContent.innerHTML;
        }
    } catch (e) {
        console.error('Failed to refresh cart drawer:', e);
    } finally {
        if (drawer) drawer.classList.remove('is-loading');
        window._isCartUpdating = false;
    }
};

window.openCartDrawer = function() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
};

window.closeCartDrawer = function() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
        drawer.classList.remove('active');
        document.body.style.overflow = '';
    }
};

window.updateCartItemAdjustment = function(key, delta) {
    const itemElement = document.querySelector(`.cart-item[data-key="${key}"]`);
    const input = itemElement?.querySelector('input');
    if (!input) return;
    const currentQty = parseInt(input.value);
    const newQty = Math.max(0, currentQty + delta);
    window.updateCartItemQuantity(key, newQty);
};

window._isCartUpdating = false;
window.updateCartItemQuantity = async function(key, quantity) {
    if (window._isCartUpdating) return;
    window._isCartUpdating = true;

    const itemElement = document.querySelector(`.cart-item[data-key="${key}"]`);
    const drawer = document.querySelector('#CartDrawer');
    const input = itemElement?.querySelector('input');
    const originalValue = input ? input.value : null;

    if (drawer) drawer.classList.add('is-loading');

    // Optimistic Update: reflect change immediately, revert on failure
    if (input) {
        input.value = quantity;
        if (quantity === 0 && itemElement) {
            itemElement.style.opacity = '0.5';
            itemElement.style.pointerEvents = 'none';
        }
    }

    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (response.ok) {
            await window.refreshCartDrawer();
        } else {
            if (input && originalValue !== null) input.value = originalValue;
            if (itemElement) {
                itemElement.style.opacity = '';
                itemElement.style.pointerEvents = '';
            }
            const err = await response.json();
            console.error('Cart update error:', err);
            // Don't alert for "no valid id" as it often happens on fast clicks/removals which we are now preventing
            if (err.message && !err.message.includes('id or line')) {
                alert('Error updating cart: ' + err.message);
            }
            await window.refreshCartDrawer(); // Refresh anyway to sync state
        }
    } catch (e) {
        if (input && originalValue !== null) input.value = originalValue;
        if (itemElement) {
            itemElement.style.opacity = '';
            itemElement.style.pointerEvents = '';
        }
        console.error('Cart update failed:', e);
        window._isCartUpdating = false;
        if (drawer) drawer.classList.remove('is-loading');
    }
};

// Predictive prefetch: fire-and-forget, fully passive, zero main-thread cost
document.addEventListener('mouseover', (e) => {
    if (e.target.closest('a[href="/cart"]') || e.target.closest('.header__icon--cart')) {
        if (!window._cartPrefetched) {
            window._cartPrefetched = true;
            const root = window.Shopify?.routes?.root || '/';
            fetch(`${root}?section_id=nglow-cart-drawer`);
        }
    }
}, { passive: true });

console.log('NGlow Cart Fix initialized.');
